import React from 'react'
import {Link} from 'react-router-dom'

const ComedyFooter = () => {
  return (
    <div className='container-fluid comedy-footer-links'>
      <div className='row'>
        <div className='col-12 comedy-footer-links-container'>
             <div>
                <p>TeluguOne Services</p>
                <Link to="https://www.teluguone.com/live/"> {'>>'} Tv Channel</Link>
                <Link to="http://www.kidsone.in/"> {'>>'} Kids One</Link>
                <Link to="https://www.teluguone.com/Comedy/"> {'>>'} Short Films</Link>
                <Link to="https://www.teluguone.com/greetings"> {'>>'} Greetings</Link>
                <Link to="https://www.teluguone.com/health/"> {'>>'} Health</Link>
                <Link to="https://www.teluguonefoundation.in/index.html"> {'>>'} Charity</Link>
             </div>  
             <div>
                <Link to="https://www.teluguone.com/tmdb/"> {'>>'} Cinema</Link>
                <Link to="https://www.teluguone.com/comedy/"> {'>>'}Comedy</Link>
                <Link to="https://www.teluguone.com/toneshop/"> {'>>'} Shopping</Link>
                <Link to="https://www.mypodcastone.com/"> {'>>'} MyPodcastOne</Link>
                <Link to="https://www.freshersadda.com/"> {'>>'} Fresher Jobs</Link>
             </div>  
             <div>
                <Link to="https://teluguone.com/news/"> {'>>'} News</Link>
                <Link to="https://www.teluguone.com/movies/"> {'>>'} Movies</Link>
                <Link to="https://www.teluguone.com/panchangam/"> {'>>'} Astrology</Link>
                <Link to="https://www.teluguone.com/games/"> {'>>'} Games</Link>
             </div>   
             <div>
                <Link to="https://www.teluguoneradio.com/"> {'>>'} Web Radio(Tori)</Link>
                <Link to="https://www.teluguone.com/videos/"> {'>>'} Videos</Link>
                <Link to="https://teluguone.com/devotional/"> {'>>'} Bhakti</Link>
                <Link to="https://teluguone.com/vanitha/"> {'>>'} Vanitha</Link>
                <Link to="https://www.teluguone.com/nri/"> {'>>'} Nri Corner</Link>
             </div>  
             <div>
                <p>TeluguOne For Your Business</p>
                <Link to="https://www.teluguone.com/advertises/index.html"> {'>>'} Ad Tariff</Link>
                <p>TeluguOne Services</p>
                <Link to="https://teluguone.com/helpdir/index.jsp?filename=/aboutus/aboutus.htm"> {'>>'} About TeluguOne</Link>
             
             </div>   

        </div>
        
        <div className='col-12  comedy-footer-middle-container'>
            
            <p>copyright ­© 2000 - {new Date().getFullYear()}, TeluguOne.com, All rights reserved.</p>
        </div>
        <div className='col-12 comedy-footer-desclaimer'> <p>Disclaimer:All content on this website—including text, images, videos, graphics, and audio—is the property of ObjectOne Information Systems Ltd. or its associates. Unauthorized reproduction, distribution, modification, or publication of any material is strictly prohibited without prior written consent..</p></div>
    </div>
  </div>
  )
}

export default ComedyFooter;
